import { ReactNode } from "react";
import { DialogServiceContext } from "./DialogServiceContext";
import { useDialogService } from "./useDialogService";

export const DialogServiceContextWrapper = ({ children }: { children: ReactNode }) => {
  const dialogService = useDialogService();

  return (
    <DialogServiceContext.Provider value={{ show: dialogService.show }}>
      {dialogService.dialogBody}
      {children}
    </DialogServiceContext.Provider>
  );
};
